module.exports = __webpack_public_path__ + "4802981024365ccecf2463960defcb24.png";